import {
  palette,
  createStyles,
  makeStyles,
} from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme) =>
  createStyles({
    error: {
      backgroundColor: palette.error.background,
      color: palette.error.dark,
      border: `1px solid ${palette.error.light}`,
      '&:hover, &:active, &:disabled': {
        backgroundColor: palette.error.background,
        color: palette.error.dark,
      },
    },
    warning: {
      backgroundColor: palette.warning.background,
      color: palette.warning.dark,
      border: `1px solid ${palette.warning.light}`,
      '&:hover, &:active, &:disabled': {
        backgroundColor: palette.warning.background,
        color: palette.warning.dark,
      },
    },
    info: {
      backgroundColor: palette.background.default,
      color: theme.palette.primary.main,
      border: `1px solid ${palette.info.light}`,
      '&:hover, &:active, &:disabled': {
        backgroundColor: palette.background.default,
        color: theme.palette.primary.main,
      },
    },
  })
);
